<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style src="./style.scss" lang="scss"></style>
<style src="@/vendor/libs/spinkit/spinkit.scss" lang="scss"></style>
<style src="@/vendor/libs/vue-notification/vue-notification.scss" lang="scss"></style>
<style src="@/vendor/libs/vue-toasted/vue-toasted.scss" lang="scss"></style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>
<style src="@/vendor/libs/vue-selecttree/vue-selecttree.scss" lang="scss"></style>
<style src="@/vendor/libs/vue-input-tag/vue-input-tag.scss" lang="scss"></style>
<style src="@/vendor/libs/sweet-modal-vue/sweet-modal-vue.scss" lang="scss"></style>

<style src="@/vendor/libs/vuejs-datepicker/vuejs-datepicker.scss" lang="scss"></style>
<style src="@/vendor/libs/vue-flatpickr-component/vue-flatpickr-component.scss" lang="scss"></style>
<style src="@/vendor/libs/vue-color/vue-color.scss" lang="scss"></style>
<style src="@/vendor/libs/vue-jstree/vue-jstree.scss" lang="scss"></style>
<style src="@/vendor/libs/vue2-datepicker/index.scss" lang="scss"></style>

<script>
export default {
  name: 'app',
  metaInfo: {
    title: 'QSNG MANAGEMENT SYSTEM',
    titleTemplate: '',
    data () {
      return {
      }
    }
  },

  methods: {
  },
  updated () {
    // Remove loading state
    // setTimeout(() => document.body.classList.remove('app-loading'), 1)
  }
}
</script>
<style>
  /*对话框重写*/
  .modal-dialog{
      max-width:100vw;
      margin-left:10%;
      margin-right: 10%;
  }
  .modal-body{
    padding: 1.1rem;
  }
  .modal-open .swal2-container{
    z-index:2000;
  }
 .modal-header {
    padding: 0.5rem 1rem !important;
}
  .swal2-container .swal2-popup {
    width: 28em;
  }
  /*选择框样式重写*/
  .light-style .multiselect__content-wrapper{
    border:none;
  }
  .dark-style .multiselect__content-wrapper{
    border:none;
  }
  .multiselect__content-wrapper{
    border:none;
  }
</style>
